@if (reportListData.length > 0) {
  @for (report of reportListData; track report) {
    <div class="row py-2" style="border-bottom: 1px solid #F4F2F1">
      <div class="col">
        <span class="overline">{{ report.date }}</span>
        <h3>{{ report.translations[currentLanguage].title }}</h3>
      </div>
      <div class="col" style="text-align: right">
        @if (report.translations['en'].pdf_file) {
          <button mat-flat-button
                  color="primary"
                  class="bp-button mt-2"
                  (click)="openPdf(report, 'en', $event)">
            Pdf (EN)
          </button>
        }
        @if (report.translations['de'].pdf_file) {
          <button mat-flat-button
                  color="primary"
                  class="bp-button mx-md-2 mt-2"
                  (click)="openPdf(report, 'de', $event)">
            Pdf (DE)
          </button>

        }
      </div>
    </div>

  }
}


